import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { Floor } from "./floor";

export class WarningFloor extends Floor {
	static key = "WarningFloor";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): WarningFloor {
		const f = new WarningFloor(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
